'use strict';
module.exports = function(data, encoding){
    return new Buffer(data, encoding);   
};
module.exports.test = function(b){
    return Buffer.isBuffer(b);
};


//////////////////
// WEBPACK FOOTER
// /Users/Adriannt/Desktop/2021.1/02 participaciones/zm_participaciones/participaciones/node_modules/jszip/lib/nodeBuffer.js
// module id = ../../../../jszip/lib/nodeBuffer.js
// module chunks = vendor